<template>
    <div class="add-user">
        <h3 class="add-user__title" v-html="$t('AddUserForm.add_user')"></h3>
        <div class="add-user__form">
            <TotemInput :placeholder="$t('AddUserForm.user_name')" v-model="firstName" />
            <TotemInput :placeholder="$t('AddUserForm.user_surname')" v-model="lastName" />
            <TotemInput :placeholder="$t('AddUserForm.user_email')" v-model="email" />
            <TotemInput :placeholder="$t('AddUserForm.supervisor_email')" v-model="supervisorEmail" />
            <TotemInput :placeholder="$t('AddUserForm.user_team')" v-model="team" />
            <TotemButton color="secondary" class="add-user__button" :label="$t('AddUserForm.add_user')" />
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                firstName: '',
                lastName: '',
                email: '',
                supervisorEmail: '',
                team: ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    .add-user {
        &__title {
            font-size: 2.2rem;
            font-family: Nunito-Bold, sans-serif;
            margin: 0 0 20px;
        }
        &__form {
            display: flex;
            flex-direction: column;
            width: 264px;

            & > input {
                margin: 0 0 20px;
            }
        }

        &__button {
            align-self: center;
        }
    }
</style>
